export const storageKeys = {
  theme: "itsweber-tools:theme",
  colorMode: "itsweber-tools:color-mode",
  favorites: "itsweber-tools:favorites",
  recent: "itsweber-tools:recent",
  language: "itsweber-tools:language",
  history: "itsweber-tools:history",
  pipes: "itsweber-tools:pipes",
} as const;
